import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible'
import VConsole from 'vconsole'

import { Toast } from 'vant';
import tools from '@/common/js/tools'
import store from './store'
import wxAuth from '@/common/js/wxAuth'
import '@/common/js/validate.js'
import '@/common/css/common.scss'
import './vant';
import utils from '@/common/js/utils'
import { apiQihooLogin } from "@/api/index"
import { securityLoad, userDetail } from '@/api/wechat/index'


//微信登录
let initWeixin = async (to) => {
  //loginType ==wx:授权后不需要绑定手机号， phone：授权后必须绑定手机号
  let loginType = to.meta.loginType ? to.meta.loginType : 'phone'
  let userInfo = sessionStorage.getItem('userInfo')
  if (userInfo) {
    userInfo = JSON.parse(userInfo)
    sessionStorage.removeItem('userInfo')
  } else {
    userInfo = store.state.userInfo || {}
  }
  if (!userInfo.token && to.name != 'login') {
    let res = await wxAuth.getUserInfo(loginType)
    if (res) {
      userInfo = res
    } else {
      return false
    }
  }
  store.commit('setUserInfo', userInfo)
  return true
}

//360登录
let qihooLogin = async (to) => {
  let publicKey = await securityLoad()
  sessionStorage.setItem('publicKey', publicKey.data)

  let res = await apiQihooLogin({
    appId: to.query.appid,
    code: to.query.code
  })

  if (res.data && res.data.key) {
    sessionStorage.setItem("userKey", res.data.key)
    await wxAuth.getUserInfoApp(res.data.key)
    return true
  } else {
    // Toast(res.message)
    sessionStorage.setItem("userPhone", res.data.phone)
    return false
  }
}

Vue.config.productionTip = false
Vue.prototype.$Toast = Toast
Vue.prototype.$tools = tools

wxAuth.$router = router
wxAuth.$store = store
tools.$router = router
// 初始环境
// tools.init()
// let vConsole = new VConsole()
if (process.env.NODE_ENV === 'development') {
  let userInfo = {
    token: "BFD9E3624C214496A6F6F4205935B9D8",
    phone: "15164369647",
    userName: "黑子",
    primaryKey: "220a699bbddd4b81b55b8cc32c4fb12e",
    avatarUrl: "http://wework.qpic.cn/bizmail/woNIVficlG2W21VVRUaibQVm2t6AXszSQanaV4QVlxiboYLMNFLefKGRA/0"
  }
  store.commit('setUserInfo', userInfo)
}

router.beforeEach(async (to, from, next) => {
  let browser = utils.BrowserInfo()
  if (browser.isWeixin && to.meta.title === '预约内部员工') {
    document.title = '预约外部员工'
  } else {
    document.title = to.meta.title || '预约';
  }

  if (to.query.channelId) {
    localStorage.setItem('channelId', to.query.channelId)
  } else if (localStorage.getItem('channelId')) {
    to.query.channelId = localStorage.getItem('channelId')
  }

  // let browser = utils.BrowserInfo()
  if (browser.isWeixin) { //微信环境
    let typeWeixin = await initWeixin(to)
    if (!typeWeixin){
      next(false)
      return
    }
  } else {  //360app
    if (!sessionStorage.getItem('token')) {
      let typeQihoo = await qihooLogin(to)
      if (!typeQihoo){
        next("/360login")
        return
      }
    } else if (!store.state.userInfo.phone && sessionStorage.getItem("userKey")) {
      await wxAuth.getUserInfoApp(sessionStorage.getItem("userKey"))
    } else if (!store.state.userInfo.phone && to.name != '360login') {
      next("/360login")
      return
    }
  }
  // 处理jssdk签名,兼容history模式
  if (!window.IOSURL) {
    window.Insure = document.URL
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() { }
}).$mount('#app')
